import { memo as Memo } from 'react';

//* Components
import Text from '@/components/global/Text';
import { CountStroke1, CountStroke2, CountStroke3, CountStroke4, CountStroke5 } from '@components/global/SvgComponents/FormCounterSvg';

//* Styles
import ContactFormStepStyle from './style';

const ContactFormStep = Memo((props) => {
	let pageCountSvg = [<CountStroke1 key={'countStroke1'} />, <CountStroke2 key={'countStroke2'} />, <CountStroke3 key={'countStroke3'} />, <CountStroke4 key={'countStroke4'} />, <CountStroke5 key={'countStroke5'} />, <CountStroke2 key={'countStroke2_1'} />, <CountStroke3 key={'countStroke3_1'} />, <CountStroke4 key={'countStroke4_1'} />];

	return (
		<ContactFormStepStyle className={`pageCountWrap ${props.active >= props.form.length - 1 ? 'deactivate' : ''}`}>
			{props.form.map((f, ind) => {
				return (
					props.form.length - 1 !== ind && (
						<li
							key={ind}
							className={`pageCount ${ind <= props.active && 'active'} p-m font-poppins font-bold`}
							onClick={() => props.onClick(ind)}>
							<Text tag={'span'}>{ind + 1}</Text>

							{ind <= props.active && pageCountSvg[ind]}
						</li>
					)
				);
			})}
		</ContactFormStepStyle>
	);
});

export default ContactFormStep;
